import * as AppConstants from 'app/AppConstants';

export const STATES = {
  INITIAL: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

function initialState() {
  return {
    state: STATES.INITIAL,
    navigation: [],
  };
}

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.HOME__NAVIGATION_LOAD_STARTED: {
      return {
        ...state,
        state: STATES.LOADING,
      };
    }

    case AppConstants.HOME__NAVIGATION_LOAD_FINISHED: {
      return {
        state: STATES.LOADED,
        navigation: action.payload.navigation,
      };
    }

    case AppConstants.HOME__NAVIGATION_LOAD_FAILED: {
      return {
        ...state,
        state: STATES.ERROR,
      };
    }

    case AppConstants.HOME__REORDER_NAVIGATION: {
      const navigation = [...state.navigation];
      const b = navigation[action.payload.to];
      navigation[action.payload.to] = navigation[action.payload.from];
      navigation[action.payload.from] = b;

      return {
        ...state,
        navigation,
      };
    }

    case AppConstants.HOME__NAVIGATION_ITEM_ADDED: {
      return {
        ...state,
        navigation: state.navigation.concat(action.payload.item),
      };
    }

    case AppConstants.HOME__NAVIGATION_ITEM_REMOVED: {
      return {
        ...state,
        navigation: state.navigation.filter(
          item => item.id !== action.payload.item.id
        ),
      };
    }

    default:
      return state;
  }
};
